import Icon from '../../../components/AppIcon';

const colorMap = {
  blue: { bg: 'bg-blue-100', text: 'text-blue-800', icon: '#3b82f6' },
  green: { bg: 'bg-green-100', text: 'text-green-800', icon: '#10b981' },
  purple: { bg: 'bg-blue-100', text: 'text-blue-800', icon: '#a855f7' },
  emerald: { bg: 'bg-emerald-100', text: 'text-emerald-800', icon: '#10b981' },
};

export default function MetricsCard({ title, value, icon, color, trend }) {
  const colors = colorMap?.[color] || colorMap?.blue;

  return (
    <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <div className={`w-12 h-12 ${colors?.bg} rounded-lg flex items-center justify-center`}>
          <Icon name={icon} size={24} color={colors?.icon} />
        </div>
        {trend && (
          <span className={`text-sm font-medium ${colors?.text}`} style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>
            {trend}
          </span>
        )}
      </div>
      <h3 className="text-2xl font-bold text-slate-900 mb-1">{value?.toLocaleString('ar-SA')}</h3>
      <p className="text-sm text-slate-600" style={{ fontFamily: 'IBM Plex Sans Arabic, sans-serif' }}>{title}</p>
    </div>
  );
}